<p-modal [open]="open" (dismiss)="close()">
  <p-heading slot="header" [size]="'large'" [tag]="'h2'">Add Members</p-heading>

  <ng-container *ngrxLet="data$ as data; error as dataError; suspenseTpl: spinner">
    @if (dataError) {
      <opa-reload-button [label]="'Reload Add Members'" (click)="reloadData()" />
    } @else if (data) {
      <form class="form" [formGroup]="form" [id]="formId" (ngSubmit)="submit()">
        <p-select-wrapper
          *ngrxLet="form.controls.members as control"
          [filter]="true"
          [label]="'Add Members'"
          [message]="control.errors?.['message'] ?? ''"
          [state]="control.touched && control.errors ? 'error' : 'none'"
        >
          <select [attr.required]="true" [formControl]="control">
            <option
              *ngFor="
                let user of data.users
                  | opaFilterGroupMembers: group?.users
                  | opaFilterSelectedUsers: control.value;
                trackBy: trackUser
              "
              [value]="user | opaJoinUsers: control.value"
            >
              {{ user.firstName }} {{ user.lastName }}
            </option>
          </select>
        </p-select-wrapper>

        <ng-container *ngrxLet="form.controls.members.value | opaStringSplit: ',' as userIds">
          <div *ngIf="userIds && userIds.length > 0">
            <p-text [color]="'contrast-medium'">{{ userIds.length }} selected:</p-text>

            <div *ngFor="let userId of userIds">
              <p-button-pure
                *ngrxLet="userId | opaFindUser: data.users as user"
                [aria]="{
                  'aria-label':
                    (user ? user.firstName + ' ' + user.lastName : userId) + ' (remove selected)',
                }"
                [iconSource]="'assets/icons/close.svg'"
                [type]="'button'"
                (click)="removeMember(userId)"
              >
                <ng-container *ngIf="user">{{ user.firstName }} {{ user.lastName }}</ng-container>
                <ng-container *ngIf="!user">{{ userId }}</ng-container>
              </p-button-pure>
            </div>
          </div>
        </ng-container>
      </form>

      <p-button-group slot="footer">
        <p-button [form]="formId" [loading]="data.submitting" [type]="'submit'">Add</p-button>
        <p-button [iconSource]="'assets/icons/close.svg'" [variant]="'secondary'" (click)="close()">
          Close
        </p-button>
      </p-button-group>
    }
  </ng-container>
</p-modal>

<ng-template #spinner>
  <opa-spinner />
</ng-template>
